"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnitType = exports.RegulationType = exports.QueryPropTypes = exports.QueryObjectsPropTypes = exports.InitialColumnGroupPropTypes = exports.CutoffType = exports.ColumnGroupPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ColumnGroupPropTypes = {
  name: _propTypes["default"].string.isRequired,
  primary: _propTypes["default"].bool.isRequired,
  groupings: _propTypes["default"].arrayOf(function (props, propName) {
    var prop = props[propName];

    if (prop === undefined) {
      return new Error("".concat(propName, " missing in ").concat(props));
    } else if (!Array.isArray(prop) || prop.length !== 2) {
      return new Error("".concat(prop, " invalid: expected array of length two"));
    } else if (typeof prop[0] !== "string") {
      return new Error("".concat(prop[0], " should be a string representing name of the grouping"));
    } else if (!Array.isArray(prop[1])) {
      return new Error("".concat(prop[1], " should be an array with members of the grouping "));
    }
  }).isRequired
};
exports.ColumnGroupPropTypes = ColumnGroupPropTypes;
var InitialColumnGroupPropTypes = Object.assign({}, ColumnGroupPropTypes, {
  selected: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["all", "ALL"]), _propTypes["default"].arrayOf(_propTypes["default"].string)])
});
exports.InitialColumnGroupPropTypes = InitialColumnGroupPropTypes;

var CutoffType = _propTypes["default"].oneOfType([_propTypes["default"].shape({
  value: _propTypes["default"].number.isRequired
}), _propTypes["default"].shape({
  foldChange: _propTypes["default"].number.isRequired,
  pValue: _propTypes["default"].number.isRequired
})]);

exports.CutoffType = CutoffType;

var RegulationType = _propTypes["default"].oneOf(["OFF", "UP", "DOWN", "UP_DOWN"]);

exports.RegulationType = RegulationType;
var UnitType = _propTypes["default"].string;
exports.UnitType = UnitType;
var QueryObjectsPropTypes = {
  specific: _propTypes["default"].bool.isRequired,
  geneQuery: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string.isRequired,
    category: _propTypes["default"].string
  }).isRequired).isRequired,
  selectedColumnIds: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  cutoff: CutoffType.isRequired,
  regulation: RegulationType.isRequired,
  unit: UnitType.isRequired
};
exports.QueryObjectsPropTypes = QueryObjectsPropTypes;
var QueryPropTypes = {
  filterFactors: _propTypes["default"].string,
  specific: _propTypes["default"].string,
  geneQuery: _propTypes["default"].string,
  cutoff: _propTypes["default"].string,
  regulation: _propTypes["default"].string,
  unit: _propTypes["default"].string
};
exports.QueryPropTypes = QueryPropTypes;